export const iOS = "iOS";
export const WINDOWS_PHONE = "Windows Phone";
export const ANDROID = "Android";
export const MAC_OSX = "MacOS";
export const MAC_OXS_CATALINA_OR_ABOVE = "MacOS Catalina";
